export const MEDIA_DOMAIN_ORIGIN = "https://media.emran.app";

// Opt in only after the domain, certificate, and deployed rewrites are verified.
export function deliveredMediaUrl(blobUrl: string): string {
    const origin = process.env.NEXT_PUBLIC_MEDIA_ORIGIN;
    if (!origin) return blobUrl;
    if (origin !== MEDIA_DOMAIN_ORIGIN) throw new Error("NEXT_PUBLIC_MEDIA_ORIGIN must be https://media.emran.app");
    const url = new URL(blobUrl);
    return `${origin}${url.pathname}${url.search}`;
}
